export enum KeyboardKey {
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
}

export enum KeyboardCharCode {
  BACKSPACE = 8,
  DELETE = 46,
  ENTER = 13
}